import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import Sidebar from "../DesignSystem/Sidebar";
import { auth } from "../../backend/firebaseconfig";
import "../../css/PortalSections/PortalSectionPage.css";

import {
  getPortalGreetingDataFromTimestamp,
  resolveFirstNameFromUser,
} from "./utils/portalGreetingHelpers";
import { ReactComponent as CalenderIcon } from "../../assets/icons/dashboard/Date.svg";
import { ReactComponent as ArrowRight } from "../../assets/icons/Arrow Right.svg";

const PortalSectionPage = ({ title, cards = [] }) => {
  const navigate = useNavigate();

  const [serverBaseTime, setServerBaseTime] = useState(null);
  const [clientBaseTime, setClientBaseTime] = useState(null);
  const [liveNow, setLiveNow] = useState(Date.now());
  const [firstName, setFirstName] = useState("");

  const server =
    process.env.REACT_APP_STAFF_SERVER_URL ||
    "https://rosemountstaffserver.onrender.com";

  useEffect(() => {
    let syncInterval;

    const fetchServerTime = async () => {
      try {
        const res = await fetch(`${server}/api/time`);
        const data = await res.json();

        const timestamp = data?.now || Date.now();

        setServerBaseTime(timestamp);
        setClientBaseTime(Date.now());
      } catch (err) {
        // console.error("Failed to fetch server time:", err);
      }
    };

    fetchServerTime();
    syncInterval = setInterval(fetchServerTime, 60000);

    return () => clearInterval(syncInterval);
  }, [server]);

  useEffect(() => {
    const tickInterval = setInterval(() => {
      setLiveNow(Date.now());
    }, 1000);

    return () => clearInterval(tickInterval);
  }, []);

  useEffect(() => {
    let mounted = true;

    const loadGreetingName = async () => {
      const name = await resolveFirstNameFromUser(auth.currentUser || {});

      if (mounted) {
        setFirstName(name);
      }
    };

    loadGreetingName();

    return () => {
      mounted = false;
    };
  }, [auth.currentUser?.uid, auth.currentUser?.email, auth.currentUser?.role]);

  const effectiveTimestamp =
    serverBaseTime && clientBaseTime
      ? serverBaseTime + (liveNow - clientBaseTime)
      : Date.now();

  const { greeting, formattedDateTime } = getPortalGreetingDataFromTimestamp(
    effectiveTimestamp,
    firstName,
  );

  return (
    <div className="Main-Page">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={`Open ${title}.`} />
      </Helmet>

      <Sidebar />

      <div className="Main-Container Lavender">
        <div className="portal-section-page">
          <div className="portal-section-hero">
            <div className="portal-section-bubbles">
              <span className="portal-section-bubble portal-bubble-1" />
              <span className="portal-section-bubble portal-bubble-2" />
              <span className="portal-section-bubble portal-bubble-3" />
              <span className="portal-section-bubble portal-bubble-4" />
              <span className="portal-section-bubble portal-bubble-5" />
              <span className="portal-section-bubble portal-bubble-6" />
              <span className="portal-section-bubble portal-bubble-7" />
            </div>

            <div className="portal-section-header">
              <div className="portal-section-hero-layout">
                <div className="portal-section-greeting-wrap">
                  {/* <div className="portal-section-greeting">{greeting}</div> */}
                  <h3 className="FP_H3">{title}</h3>
                </div>

                <div className="portal-section-info-stack">
                  <div className="portal-section-title-chip">
                    <div className="dashboard-announcements-main-header">
                      <CalenderIcon className="dashboard-announcements-main-icon" />
                      <div className="portal-section-date-value FP_Help_Text_Semibold">
                        {formattedDateTime}
                      </div>
                    </div>
                  </div>

                  {/* <div className="portal-section-title-chip">
                    <div className="portal-section-date-value">{title}</div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="portal-section-card-grid">
            {cards.map((card) => (
              <div
                key={card.route}
                className="portal-section-card"
                onClick={() => navigate(card.route)}
              >
                {card.icn ? (
                  <div className="portal-section-card-icon">
                    <card.icn />
                  </div>
                ) : null}

                <div className="FP_Subtitle_Semibold">{card.label}</div>

                <div className="FP_Content text-primary-1 ">
                  {card.description}
                </div>

                <div className="portal-section-card-arrow">
                  <ArrowRight />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortalSectionPage;
